module.exports = __webpack_public_path__ + "img/2.7ab20c3.webp";